/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Md_CopyInputs */

const en_md_copy = /** @type {(inputs: Md_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const id_md_copy = /** @type {(inputs: Md_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Md_CopyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const md_copy = /** @type {((inputs?: Md_CopyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Md_CopyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_md_copy(inputs)
	return en_md_copy(inputs)
});